  export default {
    name: 'DashboardPlanejamento',
    data() {
      return {
        dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
        dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
        usuarioUnidadeNegocioResources: this.$api.usuarioUnidadeNegocio(this.$resource),
        apuracoes: [],
        pendencias: [],
        reinvidicacoes: [],
        periodo: '',
        anos: [],
        ano: null,
        consolidadoApuracao: null,
        vazio: '',
        unidadesNegocio: [],
        idUnidadeNegocio: '',
        periodos: [],
        filtro: {},
      };
    },
    methods: {
      buscarPendencias() {
        this.dashboardApuracaoResources.pendencias()
          .then((response) => {
            this.pendencias = response.data;
          });
      },
    },
  };



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao.js